import { useState } from "react";
import { TopHeaderStyle, footerStyle1, footerStyle2 } from "../../constant";
import FooterContext from "./FooterContext";
import { randomStr } from "../../../utils/helper";

const FooterState = (props) => {
  const [formData, setFormData] = useState({
    title: "",
    contentMapId: "",
    topHeaderStyle: TopHeaderStyle,
    footer1Style: footerStyle1,
    footer2Style: footerStyle2,
  });
  const [errors, setErrors] = useState({});
  const [formDataChild, setFormDataChild] = useState({
    title: "",
    webId: localStorage.getItem("webId"),
    navMapId: "",
  });
  const [isSectionImage, setIsSectionImage] = useState("");
  const [customeIndex, setCustomeIndex] = useState("");
  /**top header form data */
  const [topHeaderForm, setTopHeaderForm] = useState({
    phone: "",
    email: "",
    image: "",
    socialMedia: [{ name: "", value: "", id: randomStr(2) }],
  });

  /**footer one form data */
  const [footerOneForm, setFooterOneForm] = useState({
    content: "",
    address: "",
    locationLink: "",
    phone: "",
    phone2: "",
    email: "",
    image: "",
    socialMedia: [{ name: "", value: "", id: randomStr(2) }],
  });

  /**footer Two form data */
  const [footerTwoForm, setFooterTwoForm] = useState({
    phone1: "",
    phone2: "",
    dialCode1: { value: "+91", label: "+91" },
    dialCode2: { value: "+91", label: "+91" },
    email1: "",
    email2: "",
    address: "",
  });
  /**footer Three form data */
  const [footerThreeForm, setFooterThreeForm] = useState({
    address1: {
      title: "",
      address: "",
      locationLink: "",
      phone: "",
      email: "",
    },
    address2: {
      title: "",
      address: "",
      locationLink: "",
      phone: "",
      email: "",
    },
    content: "",
    image: "",
    socialMedia: [{ name: "", value: "", id: randomStr(2) }],
  });

  const [collId, setCollId] = useState();
  const [settingFormData, setSettingFormData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [isParent, setIsParent] = useState(false);
  const [filter, setFilter] = useState("");
  const [navMapId, setNavMapId] = useState("");
  const [id, setId] = useState("");
  const [nameOfStyle, setNameOfStyle] = useState("");
  const [theme, setTheme] = useState(1);
  const [imgShow, setImgShow] = useState(false);
  return (
    <FooterContext.Provider
      value={{
        isEdit,
        setIsEdit,
        isParent,
        setIsParent,
        filter,
        setFilter,
        settingFormData,
        setSettingFormData,
        formDataChild,
        setFormDataChild,
        formData,
        setFormData,
        collId,
        setCollId,
        navMapId,
        setNavMapId,
        id,
        setId,
        nameOfStyle,
        setNameOfStyle,
        topHeaderForm,
        setTopHeaderForm,
        footerOneForm,
        setFooterOneForm,
        footerTwoForm,
        setFooterTwoForm,
        customeIndex,
        setCustomeIndex,
        isSectionImage,
        setIsSectionImage,
        theme,
        setTheme,
        imgShow,
        setImgShow,
        footerThreeForm,
        setFooterThreeForm,
        errors,
        setErrors,
      }}
    >
      {props.children}
    </FooterContext.Provider>
  );
};

export default FooterState;
